import React, { useState, useEffect, useRef } from "react";
import Overlay from "react-bootstrap/Overlay";
import Popover from "react-bootstrap/Popover";
import Button from "react-bootstrap/Button";
import "./report.css";
import { useReactToPrint } from "react-to-print";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { ToastContainer } from "react-toastify";
import Red_toast from "../alerts/red_toast";
import Spinner from "react-bootstrap/Spinner";
import Select from "../alerts/select";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { DateRangePicker, defaultStaticRanges } from "react-date-range";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import { Link } from "react-router-dom";
import {
  endOfDay,
  startOfYear,
  endOfYear,
  addMonths,
  addYears,
  isSameDay,
} from "date-fns";
import { useTranslation } from "react-i18next";

export default function Purchase_Report(props) {
  const user = props.state.setuser.user;
  const route = props.state.setuser.route;
  const { t } = useTranslation();
  const selected_branch = props.state.Setcurrentinfo.selected_branch;
  const current_user = props.state.Setcurrentinfo.current_user;
  const [show_company, setshow_company] = useState(false);
  const dispatch = props.Settable_history;
  const { SearchBar } = Search;
  const { ExportCSVButton } = CSVExport;
  const [details, setdetails] = useState([]);

  const [all_customers, setall_customers] = useState([]);
  const [customer, setcustomer] = useState({ value: "all", label: "All" });

  const [company, setcompany] = useState("");
  const [start_date, setstart_date] = useState(
    new Date().toISOString().substring(0, 10)
  );
  const [end_date, setend_date] = useState(
    new Date().toISOString().substring(0, 10)
  );
  const [show, setshow] = useState(false);
  const [target, setTarget] = useState(null);
  const ref = useRef(null);
  const [date_range, setdate_range] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
      showDateDisplay: "false",
    },
  ]);

  const [isloading, setisloading] = useState(false);
  const [showreport, setshowreport] = useState(false);
  const [report_type, setreport_type] = useState({
    value: "supplier",
    label: "Complete Purchase Report",
  });
  const [columns, setcolumns] = useState([]);

  useEffect(() => {
    dispatch({ type: "Set_menuitem", data: "purchase_report" });
    const fetchCompany = async () => {
      const response = await fetch(
        `${route}/api/branch/${selected_branch.id}/`,
        {
          headers: { Authorization: `Bearer ${user.access}` },
        }
      );
      const json = await response.json();

      if (response.ok) {
        setcompany(json);
      }
      if (!response.ok) {
        if (json.code === "token_not_valid") {
          dispatch({ type: "token_not_valid", data: null });
          return;
        }
        var error = Object.keys(json);
        if (error.length > 0) {
          Red_toast(`${json[error[0]]}`);
        }
      }
    };

    const fetchWorkouts = async () => {
      const response = await fetch(
        `${route}/api/parties/?branch_id=${selected_branch.id}&party_type=Supplier`,
        {
          headers: { Authorization: `Bearer ${user.access}` },
        }
      );
      const json = await response.json();

      if (response.ok) {
        const make_option = json.map((item) => {
          return { value: item.id, label: item.name };
        });

        setall_customers(make_option);
      }
      if (!response.ok) {
        if (json.code === "token_not_valid") {
          dispatch({ type: "token_not_valid", data: null });
          return;
        }
        var error = Object.keys(json);
        if (error.length > 0) {
          Red_toast(`${json[error[0]]}`);
        }
      }
    };

    if (user) {
      fetchWorkouts();

      fetchCompany();
    }
  }, [selected_branch]);

  const headerstyle = (column, colIndex) => {
    const englishHeader = column.text.english;
    const arabicHeader = column.text.arabic;

    return (
      <div>
        <div>{englishHeader}</div>
        <div>{arabicHeader}</div>
      </div>
    );
  };

  const fix_formatter = (cell, row) => {
    return <div>{parseFloat(cell).toFixed(2)}</div>;
  };

  const rowstyle = { height: "10px" };

  const handleSelect = (item) => {
    const get_date = item.selection;
    setdate_range([item.selection]);
    setstart_date(get_date.startDate.toISOString().substring(0, 10));
    setend_date(get_date.endDate.toISOString().substring(0, 10));
    if (
      get_date.startDate.toISOString().substring(0, 10) !==
      get_date.endDate.toISOString().substring(0, 10)
    ) {
      setshow(!show);
    }
  };

  const handleselectiochange = (e) => {
    setshow(!show);
    setTarget(e.target);
  };

  const componentRef = useRef();

  useEffect(() => {
    if (show_company) {
      handleprint();
    }
  }, [show_company]);

  const print = (e) => {
    e.preventDefault();
    setshow_company(true);
  };

  const handleprint = useReactToPrint({
    content: () => componentRef.current,
    bodyClass: "print_class",
    pageStyle: "@page { size: A4 landscape; }",
    onAfterPrint: () => {
      setshow_company(false);
    },
  });
  const footerFormatter = (column, colIndex, { text }) => {
    if (text !== "Total") {
      return (
        <span style={{ fontSize: "large" }}>{Number(text).toFixed(2)}</span>
      );
    } else {
      return <span style={{ fontSize: "large" }}>{text}</span>;
    }
  };

  async function fetchpurchase(row) {
    if (row.reference === "PR") {
      var url = `${route}/api/purchase-return/${row.id}/`;
    } else {
      var url = `${route}/api/purchases/${row.id}/`;
    }
    setisloading(true);

    const response = await fetch(`${url}`, {
      headers: { Authorization: `Bearer ${user.access}` },
    });
    const json = await response.json();
    setisloading(false);
    if (response.ok) {
      if (row.reference === "PR") {
        localStorage.setItem("data", JSON.stringify(json));
        if (selected_branch.invoice_type === "Version 01") {
          window.open("/invoice/purchases", "_blank");
        } else if (selected_branch.invoice_type === "Version 02") {
          window.open("/invoice_2/purchases", "_blank");
        } else if (selected_branch.invoice_type === "Version 03") {
          window.open("/invoice_3/purchases", "_blank");
        } else if (selected_branch.invoice_type === "Version 04") {
          window.open("/invoice_5/purchases", "_blank");
        } else if (selected_branch.invoice_type === "Version 05") {
          window.open("/invoice_6/purchases", "_blank");
        } else if (selected_branch.invoice_type === "Version 06") {
          window.open("/invoice_7/purchases", "_blank");
        }
      } else {
        localStorage.setItem("data", JSON.stringify(json));
        if (selected_branch.invoice_type === "Version 01") {
          window.open("/invoice/purchases", "_blank");
        } else if (selected_branch.invoice_type === "Version 02") {
          window.open("/invoice_2/purchases", "_blank");
        } else if (selected_branch.invoice_type === "Version 03") {
          window.open("/invoice_3/purchases", "_blank");
        } else if (selected_branch.invoice_type === "Version 04") {
          window.open("/invoice_5/purchases", "_blank");
        } else if (selected_branch.invoice_type === "Version 05") {
          window.open("/invoice_6/purchases", "_blank");
        } else if (selected_branch.invoice_type === "Version 06") {
          window.open("/invoice_7/purchases", "_blank");
        }
      }
    }
    if (!response.ok) {
    }
  }

  async function fetchpayments(row) {
    var url = `${route}/api/purchase-return/${row.id}`;
    const response = await fetch(`${url}`, {
      headers: { Authorization: `Bearer ${user.access}` },
    });
    const json = await response.json();

    if (response.ok) {
      setisloading(false);
      dispatch({ type: "Set_table_history", data: json });
    }
  }

  const INVOICE_formatter = (cell, row, rowIndex, formatExtraData) => {
    return row.reference === "PB" || row.reference === "PR" ? (
      <div
        onClick={() => fetchpurchase(row)}
        className="cursor-pointer"
        style={{ color: "#0d6efd" }}
      >
        {cell}
      </div>
    ) : (
      <div>{row.id}</div>
    );
  };

  const handlegenerate = async (e) => {
    e.preventDefault();
    setisloading(true);
    setshowreport(true);
    if (report_type.value === "vat") {
      var url = `${route}/api/reports/purchases-vat/?branch_id=${selected_branch.id}&start_date=${start_date}&end_date=${end_date}`;
      if (
        date_range[0].endDate.getFullYear() -
          date_range[0].startDate.getFullYear() ===
        10
      ) {
        url = `${route}/api/reports/purchases-vat/?branch_id=${selected_branch.id}`;
      }
      if (customer.value !== "all") {
        url = `${url}&supplier_id=${customer.value}`;
      }
      const column = [
        {
          dataField: "id",
          text: { english: "#", arabic: " الرقم سري" },
          headerFormatter: headerstyle,
          formatter: (cell, row, rowIndex) => {
            return rowIndex + 1;
          },
          footer: "",
        },
        {
          dataField: "date",
          text: { english: "Date", arabic: "تاريخ" },
          headerFormatter: headerstyle,
          footer: "",
        },
        {
          dataField: "reference_invoice",
          text: { english: "Invoice No.", arabic: "رقم الفاتورة" },
          headerFormatter: headerstyle,
          footer: "",
        },
        {
          dataField: "supplier",
          text: { english: "Supplier", arabic: "اسم المورد" },
          sort: true,
          headerFormatter: headerstyle,
          footer: "",
        },
        {
          dataField: "supplier_vat_number",
          text: { english: "Supp. VAT no", arabic: "رقم الضربية المورد" },
          sort: true,
          headerFormatter: headerstyle,
          footer: "",
        },
        {
          dataField: "total_quantity",
          text: { english: "Total Quantity", arabic: "الكمية الإجمالية" },
          sort: true,
          headerFormatter: headerstyle,
          footer: "Total",
          footerFormatter: footerFormatter,
        },
        {
          dataField: "sub_total",
          text: { english: "Subtotal", arabic: "المجموع الفرعي" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "discount",
          text: { english: "Discount", arabic: "الخصم" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "vat_amount",
          text: { english: "VAT Amount", arabic: "ضريبة القيمة" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "total",
          text: { english: "Total", arabic: "المجموع" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "payment_type",
          text: { english: "Payment Type", arabic: "نوعية المشتريات" },
          sort: true,
          headerFormatter: headerstyle,
        },
      ];
      setcolumns(column);
    } else if (report_type.value === "supplier") {
      var url = `${route}/api/complete-purchase-report/?branch_id=${selected_branch.id}`;

      if (
        date_range[0].endDate.getFullYear() -
          date_range[0].startDate.getFullYear() ===
        10
      ) {
        url = `${url}`;
      } else {
        url = `${url}&start_date=${start_date}&end_date=${end_date}`;
      }

      setcolumns([
        {
          dataField: "id",
          text: { english: "#", arabic: " الرقم سري" },
          headerFormatter: headerstyle,
          formatter: (cell, row, rowIndex) => {
            return rowIndex + 1;
          },
          footer: "",
        },

        {
          dataField: "supplier",
          text: { english: "Party", arabic: " حزب" },
          sort: true,
          headerFormatter: headerstyle,
          footer: "Total",
          footerFormatter: footerFormatter,
        },

        {
          dataField: "sub_total_pb",
          text: { english: "Purchase", arabic: "الشراء" },
          sort: true,
          headerFormatter: headerstyle,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "sub_total_pr",
          text: { english: "Return", arabic: "عائدات " },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "discount",
          text: { english: "Discount", arabic: "الخصم " },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "tax_amount",
          text: { english: "Tax Amt", arabic: "قيمة الضريبة " },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },

        {
          dataField: "total",
          text: { english: "Total", arabic: " المجموع" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "cash",
          text: { english: "Cash", arabic: "نقدي " },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "journal",
          text: { english: "Journal", arabic: " مجلة" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "balance",
          text: { english: "Balance", arabic: "رصيد حساب " },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
      ]);
    } else if (report_type.value === "ledger") {
      var url = `${route}/api/supplier-ledger/?branch_id=${selected_branch.id}&start_date=${start_date}&end_date=${end_date}&party_id=${customer.value}`;
      setcolumns([
        {
          dataField: "id",
          text: { english: "#", arabic: " الرقم سري" },
          headerFormatter: headerstyle,
          formatter: (cell, row, rowIndex) => {
            return rowIndex + 1;
          },
          footer: "",
        },

        {
          dataField: "reference",
          text: { english: "Ref", arabic: " المراجع" },
          sort: true,
          headerFormatter: headerstyle,
          footer: "",
        },
        {
          dataField: "date",
          text: { english: "Date", arabic: "التاريخ " },
          sort: true,
          headerFormatter: headerstyle,
          footer: "",
        },

        {
          dataField: "invoice_number",
          text: { english: "Invoice", arabic: " الفاتورة" },
          sort: true,
          formatter: INVOICE_formatter,
          headerFormatter: headerstyle,
          footer: "",
        },
        {
          dataField: "remarks",
          text: { english: "Remarks", arabic: " ملاحظات" },
          sort: true,
          headerFormatter: headerstyle,
          footer: "Total",
        },

        {
          dataField: "debit",
          text: { english: "Debit", arabic: " دَين" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "credit",
          text: { english: "Credit", arabic: "الإئتمان " },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "balance",
          text: "Balance",
          text: { english: "Balance", arabic: "رصيد حساب " },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
        },
      ]);
    } else if (report_type.value === "item") {
      var url = `${route}/api/item-purchase-report/?branch_id=${selected_branch.id}`;

      if (customer.value !== "all") {
        url = `${url}&supplier_id=${customer.value}`;
      }

      if (
        date_range[0].endDate.getFullYear() -
          date_range[0].startDate.getFullYear() ===
        10
      ) {
        url = `${url}`;
      } else {
        url = `${url}&start_date=${start_date}&end_date=${end_date}`;
      }

      setcolumns([
        {
          dataField: "id",
          text: { english: "#", arabic: "الرقم سري" },
          headerFormatter: headerstyle,
          formatter: (cell, row, rowIndex) => {
            return rowIndex + 1;
          },
          footer: "",
        },

        {
          dataField: "product__name",
          text: { english: "Product", arabic: "منتج " },
          sort: true,
          headerFormatter: headerstyle,
          footer: "Total",
          footerFormatter: footerFormatter,
        },

        {
          dataField: "quantity_pb",
          text: { english: "Purchase Qty", arabic: " كمية الشراء " },
          sort: true,
          headerFormatter: headerstyle,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "quantity_pr",
          text: { english: "Return Qty", arabic: " إرجاع الكمية" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "final_quantity",
          text: { english: "Qty", arabic: " الكمية" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "total_pb",
          text: { english: "Purchase Total", arabic: " إجمالي الشراء" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "total_pr",
          text: { english: "Return Total", arabic: " مجموع العودة" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
        {
          dataField: "final_total",
          text: { english: "Total", arabic: " المجموع" },
          sort: true,
          headerFormatter: headerstyle,
          formatter: fix_formatter,
          footer: (columnData) =>
            columnData.reduce((acc, item) => acc + item, 0),
          footerFormatter: footerFormatter,
        },
      ]);
    }

    const response = await fetch(`${url}`, {
      headers: { Authorization: `Bearer ${user.access}` },
    });
    const json = await response.json();

    if (response.ok) {
      setdetails(json.data);
      setisloading(false);
    }
    if (!response.ok) {
      setisloading(false);
      if (json.code === "token_not_valid") {
        dispatch({ type: "token_not_valid", data: null });
        return;
      }
      var error = Object.keys(json);
      if (error.length > 0) {
        Red_toast(`${json[error[0]]}`);
      }
    }
  };

  return (
    <>
      {current_user?.permissions?.includes("view_purchase_report") ? (
        <div className="p-3">
          <h1
            className="mb-3"
            style={{ fontSize: "1.8rem", fontWeight: "normal" }}
          >
            {t("side_bar_purchasereport")}
          </h1>
          <div className="card">
            <div className="card-body pt-0">
              <ToolkitProvider
                keyField="id"
                data={details}
                columns={columns}
                search
                exportCSV
              >
                {(props) => (
                  <div>
                    <form onSubmit={handlegenerate}>
                      <div className="  row mt-3">
                        <div className="col-6 col-sm-2  ">
                          {date_range[0].endDate.getFullYear() -
                            date_range[0].startDate.getFullYear() ===
                          10 ? (
                            <TextField
                              ref={ref}
                              type="button"
                              className="form-control  mb-3"
                              label={t("date")}
                              value="From Start"
                              onClick={handleselectiochange}
                              size="small"
                            />
                          ) : (
                            <TextField
                              ref={ref}
                              type="button"
                              className="form-control  mb-3 "
                              label={t("date")}
                              value={`${date_range[0].startDate
                                .toLocaleString("en-GB")
                                .substring(0, 10)} - ${date_range[0].endDate
                                .toLocaleString("en-GB")
                                .substring(0, 10)}`}
                              onClick={handleselectiochange}
                              size="small"
                            />
                          )}
                          <Overlay
                            show={show}
                            target={target}
                            placement="bottom-start"
                            container={ref}
                          >
                            <Popover
                              id="popover-contained"
                              className="pop_over"
                            >
                              <Popover.Body>
                                <div>
                                  <DateRangePicker
                                    onChange={handleSelect}
                                    showSelectionPreview={true}
                                    showCalendarPreview={false}
                                    dragSelectionEnabled={true}
                                    moveRangeOnFirstSelection={false}
                                    months={2}
                                    ranges={date_range}
                                    direction="horizontal"
                                    preventSnapRefocus={true}
                                    calendarFocus="backwards"
                                    staticRanges={[
                                      ...defaultStaticRanges,
                                      {
                                        label: "Last Year",
                                        range: () => ({
                                          startDate: startOfYear(
                                            addYears(new Date(), -1)
                                          ),
                                          endDate: endOfYear(
                                            addYears(new Date(), -1)
                                          ),
                                        }),
                                        isSelected(range) {
                                          const definedRange = this.range();
                                          return (
                                            isSameDay(
                                              range.startDate,
                                              definedRange.startDate
                                            ) &&
                                            isSameDay(
                                              range.endDate,
                                              definedRange.endDate
                                            )
                                          );
                                        },
                                      },
                                      {
                                        label: "This Year",
                                        range: () => ({
                                          startDate: startOfYear(new Date()),
                                          endDate: endOfDay(new Date()),
                                        }),
                                        isSelected(range) {
                                          const definedRange = this.range();
                                          return (
                                            isSameDay(
                                              range.startDate,
                                              definedRange.startDate
                                            ) &&
                                            isSameDay(
                                              range.endDate,
                                              definedRange.endDate
                                            )
                                          );
                                        },
                                      },
                                      {
                                        label: "From Start",
                                        range: () => ({
                                          startDate: startOfYear(
                                            addYears(new Date(), -10)
                                          ),
                                          endDate: endOfDay(new Date()),
                                        }),
                                        isSelected(range) {
                                          const definedRange = this.range();
                                          return (
                                            isSameDay(
                                              range.startDate,
                                              definedRange.startDate
                                            ) &&
                                            isSameDay(
                                              range.endDate,
                                              definedRange.endDate
                                            )
                                          );
                                        },
                                      },
                                    ]}
                                  />
                                </div>
                              </Popover.Body>
                            </Popover>
                          </Overlay>
                        </div>

                        <div className="  col-6 col-sm-2    mb-3">
                          <Select
                            options={
                              report_type.value !== "ledger"
                                ? [
                                    {
                                      value: "all",
                                      label: "All",
                                    },
                                    ...all_customers,
                                  ]
                                : [...all_customers]
                            }
                            placeholder={t("side_bar_suppliers")}
                            value={customer}
                            funct={(e) => setcustomer(e)}
                            required={true}
                          ></Select>
                        </div>

                        <div className=" col-6 col-sm-2     mb-3">
                          <Select
                            options={[
                              {
                                value: "supplier",
                                label: "Complete Purchase Report",
                              },
                              { value: "item", label: "Purchase Item Report" },
                              { value: "vat", label: "Purchase VAT Report" },
                              { value: "ledger", label: "Vendor Ledger" },
                            ]}
                            placeholder={t("report_type")}
                            value={report_type}
                            funct={(e) => {
                              setreport_type(e);
                              if (e.value == "ledger") {
                                setcustomer("");
                              } else {
                                setcustomer({ value: "all", label: "All" });
                              }
                            }}
                          ></Select>
                        </div>
                        <div className=" col-6 col-sm-2   selector  mb-3">
                          <Button
                            type="submit"
                            variant="outline-success"
                            size="small"
                          >
                            {t("generate")}
                          </Button>
                        </div>
                      </div>
                    </form>
                    {isloading && (
                      <div className="text-center">
                        <Spinner animation="border" variant="primary" />
                      </div>
                    )}

                    {showreport && (
                      <>
                        <div className="d-sm-flex justify-content-between align-items-center mt-2">
                          <div>
                            <ExportCSVButton
                              {...props.csvProps}
                              className="csvbutton me-3 border bg-secondary text-light"
                            >
                              Export CSV
                            </ExportCSVButton>
                            <Button
                              type="button"
                              className="mt-3 mb-3 me-3"
                              variant="outline-success"
                              size="small"
                              onClick={print}
                            >
                              {t("print")}
                            </Button>
                          </div>
                          <SearchBar {...props.searchProps} />
                        </div>

                        <hr />
                        <div ref={componentRef}>
                          {show_company && (
                            <div>
                              <h2 className="text-center">
                                {company.name} / {company.arabic_name}
                              </h2>
                              <h3 className="text-center">
                                VAT No: {company.vat_number} /{" "}
                                {company.vat_number_arabic}
                              </h3>
                              <hr />
                              <h3 className="text-center">
                                {report_type.label}
                              </h3>
                              <div className="p-3 d-flex justify-content-between">
                                <h6>
                                  <strong className="me-3">Date:</strong>
                                  {date_range[0].startDate
                                    .toLocaleString("en-GB")
                                    .substring(0, 10)}
                                  -
                                  {date_range[0].endDate
                                    .toLocaleString("en-GB")
                                    .substring(0, 10)}
                                  <br></br>
                                </h6>
                                <h6>
                                  <strong className="me-3">Supplier:</strong>
                                  {customer.label}
                                  <br />
                                </h6>
                              </div>
                            </div>
                          )}
                          <BootstrapTable
                            {...props.baseProps}
                            rowStyle={rowstyle}
                            striped
                            bootstrap4
                            condensed
                            classes="sale-report-table"
                            wrapperClasses="table-responsive"
                          />
                        </div>
                      </>
                    )}
                  </div>
                )}
              </ToolkitProvider>
            </div>
          </div>

          <ToastContainer
            autoClose={1000}
            hideProgressBar={true}
            theme="dark"
          />
        </div>
      ) : (
        <div
          style={{
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "30px",
            fontWeight: "bold",
            opacity: "0.7",
          }}
        >
          No Page Found
        </div>
      )}
    </>
  );
}
